/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'bot';
const componentName = 'bot-mapping-page';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const placeholderMessage = `${prefix}.placeholderMessage`;
export const ENGLISH = {
    [headerLabel]: 'Bot Mapping',
    [placeholderMessage]: 'No Items Found',
};
